import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function CookieBanner() {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('spotd_cookie_consent');
    if (!consent) setTimeout(() => setVisible(true), 1500);
  }, []);

  const accept = () => {
    localStorage.setItem('spotd_cookie_consent', 'accepted');
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem('spotd_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  // Compact one-line bar so it never hides hero CTAs. Logged-in users have a
  // bottom tab bar, so lift it above that.
  const bottom = user ? 72 : 12;
  const btn = { padding: '7px 14px', borderRadius: 100, cursor: 'pointer', fontSize: '.75rem',
    fontFamily: 'Plus Jakarta Sans,sans-serif', fontWeight: 700, flexShrink: 0 };

  return (
    <div style={{
      position: 'fixed', bottom, left: 12, right: 12, margin: '0 auto', maxWidth: 520,
      background: 'rgba(10,37,64,.94)', color: '#fff', backdropFilter: 'blur(8px)',
      borderRadius: 12, padding: '8px 8px 8px 14px',
      display: 'flex', alignItems: 'center', gap: 8,
      zIndex: 400, boxShadow: '0 4px 16px rgba(0,0,0,.18)',
      animation: 'slideUp .35s cubic-bezier(.34,1.56,.64,1)',
    }}>
      <div style={{ flex: 1, fontSize: '.72rem', lineHeight: 1.4, color: '#cbd5e1' }}>
        🍪 We use cookies. <a href="/privacy" style={{ color: '#fff', fontWeight: 700 }}>Privacy</a>
      </div>
      <button onClick={decline} style={{ ...btn, border: '1px solid #475569', background: 'transparent', color: '#cbd5e1' }}>Decline</button>
      <button onClick={accept} style={{ ...btn, border: 'none', background: '#635BFF', color: '#fff' }}>Accept</button>
    </div>
  );
}
